// src/components/controls/UnitConverter.jsx
import React from 'react';
import { Select } from '../ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const UnitConverter = ({ units, onUnitChange }) => {
  const handleTemperatureChange = (e) => {
    onUnitChange('temperature', e.target.value);
  };

  const handlePressureChange = (e) => {
    onUnitChange('pressure', e.target.value);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Unit Settings</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col space-y-4">
          <div className="flex items-center space-x-4">
            <label htmlFor="tempUnit" className="text-sm font-medium text-gray-700 w-24">
              Temperature:
            </label>
            <Select
              id="tempUnit"
              value={units.temperature}
              onChange={handleTemperatureChange}
            >
              <option value="C">Celsius (°C)</option>
              <option value="F">Fahrenheit (°F)</option>
            </Select>
          </div>
          
          <div className="flex items-center space-x-4">
            <label htmlFor="pressureUnit" className="text-sm font-medium text-gray-700 w-24">
              Pressure:
            </label>
            <Select
              id="pressureUnit"
              value={units.pressure}
              onChange={handlePressureChange}
            >
              <option value="hPa">Hectopascals (hPa)</option>
              <option value="inHg">Inches of Mercury (inHg)</option>
            </Select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default UnitConverter;